import React from 'react';
import clsx from 'clsx';

export const DropdownMenu = ({ 
  isOpen, 
  onClose, 
  children,
  className = '' 
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 z-10" 
        onClick={onClose} 
        aria-hidden="true" 
      />
      <div className={clsx(
        'absolute top-full left-0 mt-2 w-48 bg-slate-800 border border-slate-700 rounded-lg shadow-xl z-20',
        className
      )}>
        <div className="py-2">
          {children}
        </div>
      </div>
    </>
  );
};